// extracted by mini-css-extract-plugin
export default {"container":"QuestionNavigation_container__E2Oga","button":"QuestionNavigation_button__1eKvy","active":"QuestionNavigation_active__dWbR7"};